import React, { useState } from "react";
import { exportToExcel } from "../../utils/ExcelUtils";
import { getCustomersDataForExport } from "../../actions/CustomerAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSession } from "../layout/SessionContext";
import { formatDate } from "../../utils/DateFormat";

const columns = [
  { key: "uid", label: "Number" },
  { key: "createdAt", label: "Date joined" },
  { key: "mobileNumber", label: "Mobile number" },
  { key: "email", label: "Email address" },
  { key: "referral.code", label: "Referral code" },
  { key: "status", label: "Status" },
];

const Header = ({ filters, searchTerm }) => {
  const { hasPermission } = useSession();
  const [loading, setLoading] = useState(false);

  const headerMap = {};
  columns.forEach((col) => {
    // flatten nested keys (referral.code → referral_code)
    headerMap[col.key.replace(/\./g, "_")] = col.label;
  });

  const getCustomer = async () => {
    try {
      setLoading(true);
      
      // Handle N/A referral filter
      let referralValue = filters?.referralCode || "";
      let hasReferral = undefined;
      
      if (filters?.referralCode === "NA") {
        // N/A selected - filter for customers without referral
        hasReferral = "false";
        referralValue = "";
      } else if (filters?.referralCode && filters?.referralCode !== "") {
        // Specific referral selected
        referralValue = filters.referralCode;
        hasReferral = "true";
      }
      // else: All selected (empty), return all customers

      const requestData = {
        search: searchTerm || "",
        filter: {
          referral: referralValue,
          fromDate: filters?.fromDate || "",
          toDate: filters?.toDate || "",
          ...(hasReferral !== undefined && { hasReferral }), // Include only if defined
        },
      };

      const response = await getCustomersDataForExport(requestData);

      if (response?.success && response.data.length) {
        exportToExcel(
          response.data.map((customer) => ({
            ...customer,
            createdAt: formatDate(customer.createdAt),
          })),
          "Customers",
          "Customers",
          headerMap,
        );
      } else {
        toast.error(response.message || "No data to export");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 sm:px-10">
      <div className="flex flex-row justify-between items-center gap-4">
        <h1 className="font-bold text-text1 whitespace-nowrap text-[24px] sm:text-[26px] md:text-[30px]">
          Customers
        </h1>
        {hasPermission("Customers", "export") && (
          <button
            className="secondary_button text-xs sm:text-sm h-8 sm:h-10 px-3 sm:px-4 flex items-center justify-center"
            onClick={getCustomer}
            disabled={loading}
          >
            {loading ? "Exporting..." : "Export Excel"}
          </button>
        )}
      </div>
      <hr className=" border-gray-300 mt-6" />
    </div>
  );
};

export default Header;
